export default class ColorPalette extends HTMLElement {
	connectedCallback() {
		const template = document.createElement('template');
		template.innerHTML = this._template();
		this.attachShadow({mode: 'open'}).appendChild(template.content.cloneNode(true))

		const colorInput = this.shadowRoot.querySelector('.color-input');

		colorInput.addEventListener('input', (evt) => {
			if (this._setPreviewBoxColor(evt.target.value))
				this.dispatchEvent(new Event("colorChanged"));
		})

		for (const colorSample of this.shadowRoot.querySelectorAll('.color-sample')) {
			colorSample.addEventListener('click', (evt) => {
				if (this.setColor(this._rgb2hex(evt.target.style.backgroundColor)))
					this.dispatchEvent(new Event("colorChanged"));
			})
		}

		this.shadowRoot.querySelector('.modal-underlay').addEventListener('click', () => {
				this.dispatchEvent(new Event("onClose"))
				this.dispatchEvent(new Event("colorChanged"))
		})

		this.addEventListener('click', (evt) => {
			evt.stopPropagation()
		})

		this.addEventListener('keydown', (evt) => {
			if (['Enter', 'Escape'].includes(evt.key) && !evt.repeat) {
				evt.stopPropagation()
				this.dispatchEvent(new Event("onClose"))
				if (evt.key === 'Enter')
					this.dispatchEvent(new Event("colorChanged"))
			}
		})
	}

	/**
	 * @param {{color: string}?} opts
	 */
	show(opts = {}) {
		if (typeof opts.color === 'string')
			this.setColor(opts.color)
		this.removeAttribute('hidden')
		this.shadowRoot.querySelector('input').focus();
	}

	hide() {
		this.setAttribute('hidden', true);
	}

	setColor(color) {
		let hex = color ? color : '';
		if (hex.length > 3) {
			const prefix = hex.charAt(0);
			switch (prefix) {
				case 'r': {
					hex = this._rgb2hex(hex);
					break;
				}
				case '#': {
					break;
				}
				default: {
					hex = 'none';
				}
			}
		}
		let isChanged = this._setPreviewBoxColor(hex);
		this.shadowRoot.querySelector('.color-input').value = this.getCurrentColor();
		return isChanged;
	}

	getCurrentColor() {
		return this._rgb2hex(this.shadowRoot.querySelector('.color-preview').style.backgroundColor);
	}

	_setPreviewBoxColor(color) {
		const prev = this.shadowRoot.querySelector('.color-preview').style.backgroundColor || null;
		this.shadowRoot.querySelector('.color-preview').style.backgroundColor = color;
		return prev !== this.shadowRoot.querySelector('.color-preview').style.backgroundColor;
	}

	_rgb2hex(rgb) {
		rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);

		function hex(x) {
			return ("0" + parseInt(x).toString(16)).slice(-2);
		}

		try {
			return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
		} catch (e) {
			return 'none'
		}
	}

	_template() {
		return `<style> :host {display: none} </style>
				<style> @import "/ui/js/components/color-palette/style.css"; </style>
				<div class="modal-underlay"></div>
				<div class="body" tabindex="0">
					<div class="color-preview"></div>
					<input class="color-input">
					
					<button class="color-sample" style="background-color: #a6cee3"></button>
					<button class="color-sample" style="background-color: #1f78b4"></button>
					<button class="color-sample" style="background-color: #b2df8a"></button>
					<button class="color-sample" style="background-color: #6a3d9a"></button>
					<button class="color-sample" style="background-color: #b15928"></button>
					<button class="color-sample" style="background-color: #33a02b"></button>
					<button class="color-sample" style="background-color: #fb9a99"></button>
					<button class="color-sample" style="background-color: #e3211c"></button>
					<button class="color-sample" style="background-color: #fdbf6f"></button>
					<button class="color-sample" style="background-color: #ff7f00"></button>
					
					<a class="get-more-colors-link" href="https://www.color-hex.com/" target="_blank">Get more colors</a>
				</div>`;
	}
}